<template>
  <iframe :src="pdf" />
</template>

<script lang="ts">
import { useAppStore } from '@/store/app';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';

export default defineComponent({
  computed: {
    ...mapState(useAppStore, {
      pdf: store => store.pdf 
    }),
  },
})
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
